let selectedPlanB = null;
let selectedProtectionB = null;

document.addEventListener("DOMContentLoaded", function() {
  $(".plans-hero-b-slideshow").slick({
    slidesToShow: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev' id='plans-hero-b-slideshow-prev'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
    nextArrow:
      "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
  });

  document.getElementById('plans-hero-b-slideshow-prev').click()
  document.getElementById('plans-hero-b-slideshow-prev').click()

  $(".plans-hero-b-slideshow").show();

  const plansPageHero = document.getElementById('plans-hero-b-content');

  const residentialPlan = document.getElementById('plans-hero-b-choose-plan-residential-plan');
  const travelPlan = document.getElementById('plans-hero-b-choose-plan-travel-plan');

  const standardProtection = document.getElementById('plans-hero-b-choose-standard-protection');
  const advancedProtection = document.getElementById('plans-hero-b-choose-advanced-protection');

  const plansPageChoosePlanStepOne = document.getElementById('plans-hero-b-step-one');
  const plansPageChoosePlanStepTwo = document.getElementById('plans-hero-b-step-two');
  const plansPageChoosePlanStepThree = document.getElementById('plans-hero-b-step-three');

  const plansPageCheckoutButton = plansPageHero.querySelector('#checkout-button-b');
  const plansPageCheckoutLinkResidentialStandard = plansPageHero.querySelector('#cb-residential-standard-b');
  const plansPageCheckoutLinkResidentialAdvanced = plansPageHero.querySelector('#cb-residential-advanced-b');
  const plansPageCheckoutLinkTravelStandard = plansPageHero.querySelector('#cb-travel-standard-b');
  const plansPageCheckoutLinkTravelAdvanced = plansPageHero.querySelector('#cb-travel-advanced-b');

  const selectResidentialPlan = () => {
    selectedPlanB = 'residential';

    residentialPlan.classList.add('plans-hero-b-card-active');
    travelPlan.classList.remove('plans-hero-b-card-active');

    residentialPlan.querySelector('button span').innerText = 'RESIDENTIAL SELECTED';
    residentialPlan.querySelector('button svg').style.display = 'block';
    travelPlan.querySelector('button span').innerText = 'GET STARTED — $129.95/MO';
    travelPlan.querySelector('button svg').style.display = 'none';

    residentialPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-b-slideshow').slick('slickGoTo', 0);

    setTimeout(() => {
      plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const selectTravelPlan = () => {
    selectedPlanB = 'travel';

    travelPlan.classList.add('plans-hero-b-card-active');
    residentialPlan.classList.remove('plans-hero-b-card-active');

    residentialPlan.querySelector('button span').innerText = 'GET STARTED — $99.95/MO';
    residentialPlan.querySelector('button svg').style.display = 'none';
    travelPlan.querySelector('button span').innerText = 'TRAVEL SELECTED';
    travelPlan.querySelector('button svg').style.display = 'block';

    travelPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-b-slideshow').slick('slickGoTo', 1);

    setTimeout(() => {
      plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const selectStandardProtection = () => {
    selectedProtectionB = 'standard';

    standardProtection.classList.add('plans-hero-b-card-active');
    advancedProtection.classList.remove('plans-hero-b-card-active');

    standardProtection.querySelector('button span').innerText = 'STANDARD PROTECTION SELECTED';
    standardProtection.querySelector('button svg').style.display = 'block';
    advancedProtection.querySelector('button span').innerText = 'UPGRADE TO ADVANCED PROTECTION';
    advancedProtection.querySelector('button svg').style.display = 'none';

    standardProtection.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      plansPageChoosePlanStepThree.scrollIntoView({ behavior: 'smooth' })
    }, 500);
  }

  const selectAdvancedProtection = () => {
    selectedProtectionB = 'advanced';

    advancedProtection.classList.add('plans-hero-b-card-active');
    standardProtection.classList.remove('plans-hero-b-card-active');

    standardProtection.querySelector('button span').innerText = 'CONTINUE WITH STANDARD PROTECTION';
    standardProtection.querySelector('button svg').style.display = 'none';
    advancedProtection.querySelector('button span').innerText = 'ADVANCED PROTECTION SELECTED';
    advancedProtection.querySelector('button svg').style.display = 'block';

    advancedProtection.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      plansPageChoosePlanStepThree.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const checkout = (plan, protection) => {
    if (plan === 'residential') {
      if (protection === 'standard') {
        plansPageCheckoutLinkResidentialStandard.click();
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkResidentialAdvanced.click();
      } else {
        Toastify({
          text: "Please choose protection",
          duration: 3000,
          newWindow: true,
          gravity: "top",
          position: "center",
        }).showToast();

        plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });

        return;
      }
    } else if (plan === 'travel') {
      if (protection === 'standard') {
        plansPageCheckoutLinkTravelStandard.click();
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkTravelAdvanced.click();
      } else {
        Toastify({
          text: "Please choose protection",
          duration: 3000,
          newWindow: true,
          gravity: "top",
          position: "center",
        }).showToast();

        plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      Toastify({
        text: "Please choose a plan",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
      }).showToast();

      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
    }
  }

  residentialPlan.addEventListener('click', selectResidentialPlan);
  travelPlan.addEventListener('click', selectTravelPlan);
  standardProtection.addEventListener('click', selectStandardProtection);
  advancedProtection.addEventListener('click', selectAdvancedProtection);
  plansPageCheckoutButton.addEventListener('click', () => checkout(selectedPlanB, selectedProtectionB))

  residentialPlan.querySelector('button').disabled = false;
  travelPlan.querySelector('button').disabled = false;
  standardProtection.querySelector('button').disabled = false;
  advancedProtection.querySelector('button').disabled = false;
  plansPageCheckoutButton.disabled = false;

  const searchParams = new URLSearchParams(window.location.search);

  switch (searchParams.get('plan')) {
    case 'residential':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
    case 'travel':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
  }

  initializeChargebeeProductTracking('cb-residential-standard-b', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced-b', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard-b', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced-b', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
});
